import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { Input } from "stories/forms";
import { useAppContext } from "contexts/AppContext"

const DerivativeTypeInput = ({label, name="derivative_type", onChange, value, allOption = true, disabled}) => {
  const { t } = useTranslation();
  const { enums } = useAppContext()
  
  const getInputOptions = useCallback(() => {
    const inputOptions = enums?.options?.option?.derivative_type;
    return inputOptions && inputOptions.map(obj => {
      return (
        <option value={obj.key}>{obj.value}</option>
      )
    })
  }, [enums])
  
  return (
    <Input label={label ? label : t("Derivative")} type="select" name={name} onChange={onChange} value={value} disabled={disabled}>
      { allOption && (
        <option value="">{t("Kaikki")}</option>
      )}
      {getInputOptions()}
    </Input>
  )
  
  
}


export default DerivativeTypeInput;